module.exports = __webpack_public_path__ + "media/pause.e07d22e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/pause.svg
// module id = ./src/templates/app-website/assets/pause.svg
// module chunks = 0